/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";
import "./clientsidebar.scss";
// import logo from "../Header/Logo_nFiniti.svg";
import { BankUserContext } from "../../../bankUserContext";
import Service from "../../../services";
import { AxiosError, AxiosResponse } from "axios";
import { ReviewprogressDetails } from "../../../models/ClientPortalCategoriesDetails/CategoriesDetails";
import { getDisplayValue } from "../../../utils/GeneralUtils";
import { OverallPercentage } from "../../../models/LeadModels";
import { useNavigate, useParams } from "react-router-dom";
import { Modal } from "reactstrap";
import { ModalHeader } from "reactstrap";
import { ModalBody } from "reactstrap";
import { useLocation } from "react-router-dom";
import Avatar from "react-avatar";
import { catchError } from "../../.././utils/Utils";

// import RolesAuthentication from "../../../Utils/RolesUtlis";

const ClientSideBar: React.FunctionComponent = ({ isOpen, toggle, props }: any) => {
  const service = new Service();
  const [reviewData, setReviewData] = useState<any>();
  const [compliancepercentage, setCompliancepercentage] = useState<OverallPercentage>();
  const [showButtons, setShowButtons] = useState<boolean>(false);
  const [showmodal, setShowmodal] = useState(false);
  const [approveStatus, setApprovestatus] = useState<string>("");
  const context = useContext(BankUserContext);

  const navigate = useNavigate();

  const { clientProductId } = useParams();

  const bankUserContext = useContext(BankUserContext);
  const location = useLocation();





  const getReviewProgress = () => {
    clientProductId && service.getReviewProgress(clientProductId).then((response: AxiosResponse<ReviewprogressDetails>) => {
      setReviewData(response.data);

    }).catch((error: any) => {
      catchError(error, true)
    })

  }
  const getComplianceOverallPercentage = () => {
    clientProductId && service
      .getComplianceOverallPercentage(clientProductId)
      .then((response: AxiosResponse<OverallPercentage>) => {
        setCompliancepercentage(response.data);

      }).catch((error: AxiosError) => {
        catchError(error, true);
      });
  }

  const approveClient = async (reviewStatus: string) => {
    try {
      if (!clientProductId) return;


      await service.postSubmitCompliance(clientProductId, reviewStatus);

      const payload = {
        "orgId": context.bankuserDetails?.organization.orgId,
        "screen": "getAcceptButtonStatus",
        "clientProductId": clientProductId,
        "sections": "getAcceptStatus",
        "isJsonReturnObject": false
      };


      const response = await service.getAcceptStatus(payload);

      setShowmodal(false);

      const data = {

        "screen": "getClientId",
        "sections": "getClientIdByClientProductId",
        "clientProductsId": clientProductId,
        "isJsonReturnObject": false
      };

      const response2 = await service.clientIdByClientProductId(data);

      if (response2.data[0].clientid) {
        const { clientid } = response2.data[0];
        const destination = `/trackerDetailsPage/underwriting/${clientid}/${clientProductId}`;
        navigate(destination);
      }

      await getReviewProgress();
      await getComplianceOverallPercentage();
      bankUserContext.updateComplainceDashboardPage(true);


    } catch (error) {
      catchError(error, true);
    }
  };


  const showButtonsApi = () => {
    const payload =
    {
      "orgId": context.bankuserDetails?.organization.orgId,
      "screen": "getAcceptButtonStatus",
      "clientProductId": clientProductId,
      "sections": "getAcceptStatus",
      "isJsonReturnObject": false
    }
    service.getAcceptStatus(payload).then((response: AxiosResponse<any>) => {
      if (response.status === 200) {
        setShowButtons(response.data[0].is_accept)
      }
    }).catch((error: any) => {
      catchError(error, true);

    })
  }


  useEffect(() => {
    getReviewProgress();
    if (location.pathname.indexOf("clientQuestionarie/compView") === 1) {
      // getComplianceOverallPercentage();
      showButtonsApi()
    }

  }, [location]);

  const DownloadFile = () => {
    // service
    // .getChecklistReport(bankUserContext.clientId)
    // .then((response: any) => {
    //   const blob = new Blob([response.data], { type: "application/octet-stream" })
    //   const link = document.createElement('a')
    //   link.href = window.URL.createObjectURL(blob)
    //   link.download = 'AccountOpeningChecklist.xlsx';
    //    link.click()
    // })
    // .catch((error: any) => catchError(error,true));
  }

  return (
    <>

      <div className="">
        <div className={classNames("clientsidebar pt-3", { "is-open": isOpen })}>
          <div className="sidebar-header">
            <span color="info" onClick={toggle} style={{ color: "#fff" }}>
              &times;
            </span>
          </div>
          <div className="side-menu">
            <div>
              {/* <img src={logo} alt="Logo" className="sidebarLogo" /> */}
            </div>
            <div className="secondaryLogo">
              <Avatar size="90px" textSizeRatio={2} textMarginRatio={0.20} round name={reviewData?.company} />
            </div>
            <div className="text-center">
              <h1 className="clientCompanyname">{reviewData?.company}</h1>
              <p className="clientname">Account Application</p>
              <h3 className="orgType">Org. Type</h3>
              <p className="clientname">{getDisplayValue(reviewData?.orgType)}</p>
              <h3 className="orgType">Business Type</h3>
              <p className="clientname">{getDisplayValue(reviewData?.bussinessType)}</p>
            </div>

            {(location.pathname.indexOf("compView") > -1 && (location.pathname.indexOf("clientQuestionarie/questionarie/compView") === -1) ||
              location.pathname.indexOf("complianceView/managmentReview") === 1) &&
              (
                <div className="reviewsection">
                  <div>
                    <p className="reviewsubcomponentstext">Review Eligible</p>
                    <p className="reviewsubcomponentstext">
                      {getDisplayValue(reviewData?.reviewedEligible)}
                    </p>
                  </div>
                  <div>
                    <p className="reviewsubcomponentstext">Review Started</p>
                    <p className="reviewsubcomponentstext">
                      {getDisplayValue(reviewData?.reviewedStarted)}
                    </p>
                  </div>
                  <div>
                    <p className="reviewsubcomponentstext">Review Completed</p>
                    <p className="reviewsubcomponentstext">
                      {getDisplayValue(reviewData?.reviewedCompleted)}
                    </p>
                  </div>
                  <div>
                    <p className="reviewsubcomponentstext">Reviewed By</p>
                    <p className="reviewsubcomponentstext">
                      {getDisplayValue(reviewData?.reviewedBy)}
                    </p>
                  </div>

                  {showButtons
                    ? (
                      // <div>
                      //   <button
                      //     className="approvebtn"
                      //     onClick={() => {
                      //       setShowmodal(true);
                      //       setApprovestatus("Approve");
                      //     }}
                      //   //  disabled={roles.isSuperUser(bankUserContext?.bankuserDetails?.roles)}
                      //   >
                      //     Approve
                      //   </button>
                      //   <button
                      //     className="declinebtn"
                      //     onClick={() => {
                      //       setShowmodal(true);
                      //       setApprovestatus("Decline");
                      //     }}
                      //   // disabled={roles.isSuperUser(bankUserContext?.bankuserDetails?.roles)}
                      //   >
                      //     Decline
                      //   </button>
                      // </div>
                      <p className="summaryfindings">
                        <a onClick={() => window.open(`/complianceView/getSummaryReport/${bankUserContext.clientId}/${clientProductId}`)}>
                          Review Report</a>
                      </p>

                    ) : (
                      ""
                    )}

                  {/* Review Completed                  */}
                  {compliancepercentage?.status === "Review Completed" && (
                    <div>
                      {/* <p className="accountopening">
                        <a onClick={DownloadFile}>Account Opening Checklist</a>
                      </p> */}
                      <p className="summaryfindings">
                        <a onClick={() => window.open(`/complianceView/getSummaryReport/${bankUserContext.clientId}/${clientProductId}`)}>
                          Summary Findings Report</a>
                      </p>
                    </div>
                  )}
                  {/* {location.pathname.indexOf("complianceview/mangmentReview") > -1 && (
                    <div>

                      <p className="summaryfindings">
                        <a onClick={()=>window.open(`complianceView/getSummaryReport/${bankUserContext.clientId}/${clientProductId}`)}>
                        Summary Findings Report</a>
                      </p>
                    </div>
                  )} */}
                </div>
              )}
          </div>
        </div>
        <Modal
          className="popup-modal inviteModal approveAppModal"
          size="md"
          isOpen={showmodal}
          toggle={() => setShowmodal(!showmodal)}
        >
          <ModalHeader
            className="modalheaderSendingInvitation"
            toggle={() => setShowmodal(!showmodal)}
          >
            {" "}
            {approveStatus} Application ?
          </ModalHeader>
          <ModalBody>
            {approveStatus === "Approve" ? (
              <p>
                This application will be approved and sent for <br />
                account creation. This action cannot be undone.
              </p>
            ) : (
              <p>
                This application will be declined.
                <br />
                This action cannot be undone.
              </p>
            )}
            <div className="footer">
              <button className="cancelBtn" onClick={() => setShowmodal(false)}>
                Cancel
              </button>
              <button
                className={
                  approveStatus === "Approve" ? `approvebtn` : `declineBtn`
                }
                onClick={() => approveClient(approveStatus)}
              >
                {approveStatus}
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  )
}

export default ClientSideBar;
